<div class="row mb-3">
  <div class="col-lg mb-3">
    <div class="card status-list-item-base flex-column flex-md-row">
      <div class="infobar flex-row flex-md-column">
        <div class="media-holder">

          @if(image() && !statusIconClass){
            <img [src]="image() | imageUrl:imageTransformations"
              [alt]="image()?.alt_text"
              />
          }
          @if(icon && !image() && !statusIconClass){
            @if (icon.identifier_1) {
              <i [class]="icon.identifier_1"></i>
            }
            @if (!icon.identifier_1 && icon.identifier_2) {
              <img [src]="cloudinary_base_url+'w_32,c_fill,ar_1:1,r_max/'+icon.identifier_2+'.svg'" class="mr-1">
            }
          }

          @if (statusIconClass) {
            <span>
              <i [class]="statusIconClass"></i>
            </span>
          }
          @if (statusLabelTranslationKey || statusLabelText) {
            <span>
              <span *transloco="let t">{{statusLabelTranslationKey ? t(statusLabelTranslationKey) : statusLabelText }}</span>
            </span>
          }
        </div>

        <!-- Place your icon code here -->

        @if (minutes) {
          <div class="timer">
            <i class="fa-solid fa-hourglass-half"></i>
            <span class="ml-2">{{round(minutes)}}:00</span>
            <span class="ml-1" *transloco="let t">{{t('common.minutes_abbreviated')}}</span>
          </div>
        }
        <!-- <hr class="w-50 my-0" /> -->
        <!-- <div class="award-star">
        <span class="value">+2</span>
        <i class="fa-solid fa-star"></i>
      </div> -->
    </div>
    <div
      class="card-body p-2 d-flex flex-column justify-content-between gap-2"
      >
      <div class="content">
        <div class="title-group">
          <h5 class="card-title font-weight-bold">
            {{ title }}
          </h5>
          @if (titleIconClass) {
            <span class="icons-holder">
              @if (titleIconClass) {
                <span><i [class]="titleIconClass"></i></span>
              }
            </span>
          }
        </div>
        <p class="card-text">{{ description }}</p>
      </div>
      <div class="actions flex-column flex-md-row mt-2">
        @if (progressValue && progressValue < 100) {
          <div
            class="mini-progress-bar"
            [style]="'--progress-value: ' + progressValue + '%'"
            [attr.aria-valuenow]="progressValue"
            aria-valuemin="0"
            aria-valuemax="100"
            aria-labelledby="progresslabel"
            >
            <div class="bar">
              <div class="fill"></div>
            </div>
          </div>
        }

        <button type="button" class="btn btn-primary align-self-end">
          <span *transloco="let t">
            <span>
              {{
              buttonTextTranslationKey
              ? t(buttonTextTranslationKey)
              : buttonText
              }}
            </span>
          </span>
          <i class="ml-2 fa-solid fa-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>
</div>
